<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" :width="size ? size : 512" :height="size ? size : 512"
         :class="[color]" x="0" y="0" viewBox="0 0 48 48" style="enable-background:new 0 0 512 512" xml:space="preserve">
        <g><g xmlns="http://www.w3.org/2000/svg" id="21-audio,-low,-sound,-speaker,-volume" fill="none" fill-rule="evenodd"><path id="Shape" d="m26.3802778 6.3571681c2.5079846-2.17358663 6.6197222-.53913938 6.6197222 3.02275633v31.24015117c0 3.0227563-3.597709 5.4736141-6.6197222 3.0227563l-11.1262778-9.6428319h-4.254c-2.07309232 0-4-1.6489554-4-4v-10c0-2.1421954 1.80981896-4 4-4h4.253zm12.852778 11.3723756c1.1490808 1.8719089 1.7669442 4.0281996 1.7669442 6.2704563 0 2.7782202-.9494985 5.4163908-2.6595287 7.5341748-.6939222.8593868-1.953128.9935224-2.8125148.2996002s-.9935224-1.953128-.2996002-2.8125148c1.1406001-1.4125743 1.7716437-3.1659217 1.7716437-5.0212602 0-1.4982089-.4105819-2.9311048-1.1759027-4.1778499-.5778573-.941358-.2831818-2.1729252.6581761-2.7507825s2.1729251-.2831819 2.7507824.6581761z" fill="#000000" fill-rule="nonzero" data-original="#000000" class=""></path></g></g>
    </svg>
</template>

<script>
export default {
    name: "IconVolumeLow",
    props: ['color', 'size'],
}
</script>

<style lang="scss" scoped>
path{fill:white}

.dark{
    path{
        fill:#4a4a5a;
    }
}
</style>
